// extracted by mini-css-extract-plugin
export var project_thumbnail_wrapper = "ProjectThumbnail-module--project_thumbnail_wrapper--lAVh0";
export var project_thumbnail = "ProjectThumbnail-module--project_thumbnail--eJBsv";